import { Component, OnInit, Input, Output, EventEmitter, AfterViewInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { fciWebsiteService } from '../../service/fci-website.service';
import { CustomServiceService } from '../../service/custom-service.service';
import {  EncryptDecryptService } from '../../service/encrypt-decrypt.service';
import { HttpEvent, HttpEventType } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { FormControl, FormGroup, Validators } from '@angular/forms';
declare let $: any;
import * as CryptoJS from "crypto-js";
import { Buffer } from 'buffer';
import { TranslateService } from '@ngx-translate/core';
@Component({
  selector: 'app-handbook', 
  templateUrl: './handbook.component.html',
  styleUrls: ['./handbook.component.css']
})
export class HandbookComponent implements OnInit, AfterViewInit {
 
  constructor(private fciwebservice: fciWebsiteService, private httpservice: CustomServiceService, private routerparam: ActivatedRoute, private encDec:EncryptDecryptService,private route: Router,public translate: TranslateService) { }
  backend_url: any = environment.serviceURL;
  start:number=0;
  limit:number=18;
  currentPage:number = 1;
  totalRecords:number=0;
  language:any='';

  plugin_menu_dtl:any;
  employee_con:any="";
  showEmpMen:boolean=false;
  showNavComponent:boolean=false;
  showBarComponent:boolean=false;
  CurrentRouteFn:any = ():any => {
    let route_url:any = this.route.url.replace('/',"");
    route_url = route_url.split("?");
    if(route_url.length > 0){
      return route_url[0];
    }
    return route_url;
  }
  envData:any = environment;
  CURRENT_ZONE_ID:any = environment.ZONE_ID;
  CURRENT_REGION_ID:any = environment.REGION_ID;
  CURRENT_ZONE_CODE:any = environment.ZONE_CODE;
  CURRENT_REGION_CODE:any = environment.REGION_CODE;
  datetime:any = this.httpservice.currentDateTime(); 
  ngOnInit(): void {  
    this.language = sessionStorage.getItem('locale');//dynamic
    document.title='Hand Book';
    this.start=(this.currentPage - 1)*this.limit;
    this.getHandBook(this.start,this.limit,this.currentPage);

    this.employee_con = this.routerparam.snapshot.queryParamMap.get('emp');
    if(this.employee_con==null){
      this.plugin_menu_dtl = window.sessionStorage.getItem(btoa(this.CurrentRouteFn()));
      this.getPluginPageDetials(this.plugin_menu_dtl);
    } else {
      this.getEmployeeCornerDtl(this.encDec.decText(this.employee_con));
    }
  }
 
  ngAfterViewInit(): void {
    //FOR SCROLLING TO TOP WHEN COMPONENT LOADS
    // $('html, body').scrollTop(0);
  }


  pageChanged(page: any) {
    this.currentPage=page
    this.start=(this.currentPage - 1)*this.limit;
    this.getHandBook(this.start,this.limit,this.currentPage);
  }

  hb_apirespons: any;
  handbookList: any[] = [];
  getHandBook(start:number,limit:number,currentPage:number) { 
    var query:any=[
      { "columnName": "tinPublishStatus", "operator": "=", "value": "1", "joinoperator": "and" },
      { "columnName": "bitDeletedFlag", "operator": "=", "value": "0", "joinoperator": "and" },
      { "columnName": "INTTYPE", "operator": "=", "value": 4, "joinoperator": "and" },
    ]; 
    if(environment.ZONE_ID  > 0){
        query.push({ "columnName": "ZONE_ID", "operator": "=", "value": environment.ZONE_ID, "joinoperator": "and" });
    }
    let params = [
      {
        "secSlNo": 1,
        "offSet": start,
        "noOfRecords":limit,
        "orderBy": [{ "columnName": "intId", "type": "DESC" }], 
        "condition": query,
        "viewParameters": ""
      }];
    this.httpservice.getHandBookList(params).subscribe((response: any) => {
      switch (response.type) { 
        case HttpEventType.Sent:
          //console.log('Sent' + HttpEventType.Sent);
          break;
        case HttpEventType.ResponseHeader:
          //console.log('ResponseHeader' + HttpEventType.ResponseHeader);
          break;
        case HttpEventType.UploadProgress: 
          //  let total = response.total?response.total:0;
          //  console.log(Math.round(response.loaded / total * 100));
          break; 
        case HttpEventType.Response:
        this.hb_apirespons = response.body;
        let respData = this.hb_apirespons.RESPONSE_DATA;
        let respToken = this.hb_apirespons.RESPONSE_TOKEN;
        let verifyToken = CryptoJS.HmacSHA256(respData,environment.apiHashingKey).toString();
        if (respToken == verifyToken) {
          let response_: any = Buffer.from(respData, 'base64');
          response_ = JSON.parse(response_);
          this.handbookList = response_.result.sec_1;
          console.log(this.handbookList);
          if(response_.result.sec_1.length > 0){
            this.totalRecords = response_.result.sec_1[0].noOfRec;
          } else {
            this.totalRecords = 0; 
          }
        }  
      }
    });
  }

  checkImageFile(item:any):boolean{
    if(item== null || item== ''){
      return false;
    }
    let itemIs = item;
    if(itemIs.image==null){
      return false;
    } else if(itemIs.image==''){
      return false;
    } else if(itemIs.image_details==undefined){
      return false;
    } else if(itemIs.image_details.fileSize==''){
      return false;
    } else {
      return true;
    }
  }


 
  jsonConvert(data: any, type: any) {
    if(data=="" || data==null){
      return "";
    }
    if(data.jsonOptTxtDetails=="" || data.jsonOptTxtDetails == null){
      return "";
    }
    let d = JSON.parse(data.jsonOptTxtDetails);
    if (type == 'ZONE_ID') {
      return d.ZONE_ID;
    } else if (type == 'LINK_ID') {
      return d.LINK_ID;
    } else if (type == 'REGION_ID') {
      return d.REGION_ID;
    } else {
      return '';
    }


    //  return '';
    // console.log(JSON.parse(data.jsonOptTxtDetails));
  }

htmlTag(data:any){
  return this.encDec.decodeHtml(data);
}


checkFileExists(obj:any):boolean{
  if(obj.documents==""){
    return false;
  }
  if(obj.documents_details==undefined){
    return false;
   }
  if(obj.documents_details.fileSize==undefined){
    return false;
   }
 if(obj.documents_details.fileSize==""){
  return false;
 }
return true;
}

Files_:any = (data:any)=>{
  if(data==""){
    return [];
  }
  if(data.length <= 0){
    return [];
  }
  var list = [];
  for (let i = 0; i < data.length; i++) {
      if(data[i].selectFile!==''){
        if(data[i].selectFile_details.fileSize!==''){
          list.push(data[i]);
        }
      }  
  } 
  return list;
}



emp_apires:any;
  emp_dtl:any={'title':''};
  getEmployeeCornerDtl(id:any){
    let params = [
      {
        "secSlNo": 1,
        "offSet": 0,
        "noOfRecords": 0,
        "orderBy": [],
        "condition": [ 
          { "columnName": "tinPublishStatus", "operator": "=", "value": "1", "joinoperator": "and" },
          { "columnName": "bitDeletedFlag", "operator": "=", "value": "0", "joinoperator": "and" },
          { "columnName": "intId", "operator": "=", "value":id, "joinoperator": "and" },
        ],
        "viewParameters": ""
      }];
    this.httpservice.EmpeeloyCorner(params).subscribe((response: HttpEvent<any>) => {
      switch (response.type) {
        case HttpEventType.Sent:
          //console.log('Sent' + HttpEventType.Sent);
          break;
        case HttpEventType.ResponseHeader:
          //console.log('ResponseHeader' + HttpEventType.ResponseHeader);
          break;
        case HttpEventType.UploadProgress:
          //this.evenTotal = response.total;
          //this.progress = Math.round(response.loaded / this.evenTotal * 100);
          break; 
        case HttpEventType.Response:
        this.emp_apires = response.body;
        let respData = this.emp_apires.RESPONSE_DATA;
        let respToken = this.emp_apires.RESPONSE_TOKEN;
        let verifyToken = CryptoJS.HmacSHA256(respData,environment.apiHashingKey).toString();
        if (respToken == verifyToken) { 
          let response_: any = Buffer.from(respData, 'base64');
          response_ = JSON.parse(response_);
          if(response_.result.sec_1.length > 0){
            this.emp_dtl=response_.result.sec_1[0];
            this.showBarComponent=true;
            this.showEmpMen = true;
          }
        } 
      }
    });
  }











  navmenuloadCss = "background-color: #167a44; height: 100%;";
  p_apirespons: any;
  P_data: any;

  navMenu:boolean=false;
  getPluginPageDetials(details:any) {
    let params;
    if(details!==null){
      let d = JSON.parse(details);
       params = {
        "zone_id": environment.ZONE_ID,
        "zone_code": environment.ZONE_CODE,
        "region_id": environment.REGION_ID,
        "region_code": environment.REGION_CODE,
        "plugin_id": d.plugin_id,
        'router_link':d.selectPlugin,
        'localdata':true,
      };
    } else{ 
       params = {
        "zone_id": environment.ZONE_ID,
        "zone_code": environment.ZONE_CODE,
        "region_id": environment.REGION_ID,
        "region_code": environment.REGION_CODE,
        "plugin_id": false,
        'router_link':this.CurrentRouteFn(),
        'localdata':false,
      };
    }
    this.httpservice.PluginPageDetials(params).subscribe((response: HttpEvent<any>) => {
      switch (response.type) {
        case HttpEventType.Sent:
          //console.log('Sent' + HttpEventType.Sent);
          break;
        case HttpEventType.ResponseHeader:
          //console.log('ResponseHeader' + HttpEventType.ResponseHeader);
          break;
        case HttpEventType.UploadProgress:
          //this.evenTotal = response.total;
          //this.progress = Math.round(response.loaded / this.evenTotal * 100);
          break;
        case HttpEventType.Response:
        this.p_apirespons = response.body;
        let respData = this.p_apirespons.RESPONSE_DATA;
        let respToken = this.p_apirespons.RESPONSE_TOKEN;
        let verifyToken = CryptoJS.HmacSHA256(respData,environment.apiHashingKey).toString();
        if (respToken == verifyToken) { 
          let response_: any = Buffer.from(respData, 'base64');
          response_ = JSON.parse(response_);
          // console.log(response_.original);
          if(response_.original.status){
            this.P_data = response_.original;
            this.navMenu = response_.original.hasMenu;
            this.navmenuloadCss = "height: 100%;";
          } else {
            this.P_data = response_.original;//somthing wrong
          }
          this.showNavComponent=true;
          this.showBarComponent=true;
        } 
      }
    });
  }

  checkFileType(data:any):any{
    let ext:any,fileType:any;
    ext= ['webp','jpeg', 'jpe', 'png', 'gif', 'jpg', 'pdf', 'PNG','xlsx','xls','csv','docx','doc'];
    if(data==""){
      return false; 
    }  
    if(data.documents==""){
      return false; 
    }
    if(data.documents_details==undefined){
      return false; 
    }
    if(data.documents_details.fileType==undefined){
      return false; 
    }
    if(data.documents_details.fileType==''){
      return false; 
    }
    fileType=data.documents_details.fileType.toLowerCase();
    if(fileType=='xlsx' || fileType=='xls' || fileType=='csv'){
      return {'fileType':fileType,'file': ` <i class="fa fa-file-excel-o" aria-hidden="true"></i> ${fileType}`}; 
    } else if(fileType=='docx' || fileType=='doc'){
      return {'fileType':fileType,'file':` <i class="fa fa-file-word-o" aria-hidden="true"></i> ${fileType}`}; 
    } else if(fileType=='pdf'){
      return {'fileType':fileType,'file':` <i class="fa fa-file-pdf-o" aria-hidden="true"></i> ${fileType}`}; 
    } else {
      return {'fileType':fileType,'file':` <i class="fa fa-file-text" aria-hidden="true"></i> ${fileType}`}; 
    }
  
  }


}
